import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GroupSelector from '../Common/GroupSelector/GroupSelector';
import ContentService from '../../apiclients/ContentService';
import { canEditCurrentContent } from '../../helpers';

class GroupSelectorWrapper extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    handleGroupSelected = async (groupId) => {
        if (this.props.disabled !== true) {
            let response = await ContentService.setContentGroup(this.props.node.contentId, groupId);
            this.props.updateNode(response);
        }
    }

    handleRemoveGroup = async () => {
        if (this.props.disabled !== true) {
            let response = await ContentService.removeContentGroup(this.props.node.contentId);
            this.props.updateNode(response);
        }
    }

    render() {
        let disabled = this.props.disabled;
        if (this.props.disabled !== true) {
            disabled = !canEditCurrentContent(this.props.node);
        }
        return (
            <GroupSelector
                onGroupSelected={this.handleGroupSelected}
                selectedGroup={this.props.node.groupId}
                removeGroup={this.handleRemoveGroup}
                disabled={disabled}
            />
        );
    }
}
GroupSelectorWrapper.propTypes = {
    disabled: PropTypes.bool.isRequired,
    node: PropTypes.object.isRequired,
    updateNode: PropTypes.func.isRequired,
};
export default GroupSelectorWrapper;